import React from 'react';

//Reactstrap
import { Container, Row, Col,
     CardImg, CardBody, CardTitle, CardSubtitle, CardText
     //, Button
} from 'reactstrap';
//Stylos
import './SectionServicios.scss';

//imagenes
import img1 from './Images/Productos.svg';
import img2 from './Images/innovar.svg';
import img3 from './Images/Construyamos.svg';

export default class Servicios extends React.Component{
  render(){
    return(
      <div className="section-Servicios">
        <h1 className="Section-Tittle">Nuestros Servicios</h1>
        <Container>
          <Row>
            <Col lg="1" md="2" sm="0" xs="0" ></Col>
            <Col lg="10" md="8" sm="12" xs="12" >
              <Container>
                <Row>
                  <Col className={"Nuestros-Productos Section-servicios "} lg="4" md="12" sm="12" xs="12">
                    <CardImg src={img1} />
                    <CardBody>
                      <CardTitle>Nuestros Productos</CardTitle>
                      <CardText>Nuestros productos cuentan con innovación, versatilidad y viabilidad, dando así un incremento en productivo.</CardText>
                      {/*<Button color="secundary" >Cotizar</Button>*/}
                    </CardBody>
                  </Col>
                  <Col className={"Ayudanos-innovar Section-servicios "} lg="4" md="12" sm="12" xs="12">
                    <CardImg src={img2} />
                    <CardBody>
                      <CardTitle>Ayudanos a innovar</CardTitle>
                      <CardSubtitle>Conoce nuestros servicios, y danos a conocer tus ideas, para construir nuevos productos</CardSubtitle>
                      <CardText></CardText>
                      {/*<Button color="secundary">Cotizar</Button>*/}
                    </CardBody>
                  </Col>
                  <Col className={"Construir-tendencias Section-servicios "} lg="4" md="12" sm="12" xs="12">
                    <CardImg src={img3} />
                    <CardBody>
                      <CardTitle>Construyamos Nuevas Tendencias</CardTitle>
                      <CardSubtitle>Danos a conocer tus ideas para hacerlas realidad compactas y viables para el mercado.</CardSubtitle>
                      <CardText></CardText>
                      {/*<Button color="secundary">Cotizar</Button>*/}
                    </CardBody>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col lg="1" md="2" sm="0" xs="0" ></Col>
          </Row>
        </Container>
        
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Section-servicios/SectionServicios.jsx